<template>
  <div style="text-align:center;">
    <table border="1" style="border-bottom:0">
      <!-- 第一行(1表) -->
      <tr style="height:100px">
        <td width="25%" colspan="2" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="50%" colspan="3" class="titleSpan tableTitle">项 目 网 上 公 示 记 录</td>
        <td style="border:0" colspan="2" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <tr style="height:60px">
        <td width="18%" class="titleSpan">项目名称</td>
        <td class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:200px">
        <td width="18%" class="titleSpan">项目简介</td>
        <td class="contentSpan">{{`xxxxxxxxx`}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:80px">
        <td width="18%" class="titleSpan">项目组成员</td>
        <td width="22%" class="contentSpan">xxxxxx</td>
        <td width="16%" class="titleSpan">技术负责人</td>
        <td width="14%" class="contentSpan">xxxxxx</td>
        <td width="16%" colspan="2" class="titleSpan">过程控制负责人</td>
        <td class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:70px">
        <td width="18%" rowspan="2" class="titleSpan">报告编制人</td>
        <td width="22%" colspan="2" class="contentSpan">xxxxxx</td>
        <td width="16%" colspan="2" class="titleSpan">报告审核人</td>
        <td width="14%" colspan="2" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:70px">
        <td width="22%" colspan="2" class="titleSpan">参与评价工作的安全评价师</td>
        <td colspan="4" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:70px">
        <td width="22%" style="box-sizing:border-box;padding:0 30px" class="titleSpan">到现场展开安全评价的人员</td>
        <td colspan="6" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:70px">
        <td width="22%" style="box-sizing:border-box;padding:0 30px" class="titleSpan">参与安全评价的技术专家</td>
        <td colspan="6" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:70px">
        <td width="22%" style="box-sizing:border-box;padding:0 30px" class="titleSpan">现场任务</td>
        <td colspan="6" class="contentSpan">xxxxxx</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:70px">
        <td width="18%" class="titleSpan">到现场时间</td>
        <td width="30%" class="contentSpan">xxxxxx</td>
        <td width="20%" class="titleSpan">提交报告时间</td>
        <td class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:200px">
        <td width="18%" class="titleSpan">评价结论</td>
        <td colspan="3" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:200px">
        <td width="18%" class="titleSpan">影像资料</td>
        <td colspan="3" class="contentSpan">xxxxxx</td>
      </tr>
      <tr style="height:70px">
        <td width="18%" class="titleSpan">备注</td>
        <td colspan="3" class="contentSpan">xxxxxx</td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>